import axios from "axios"
import { AUTH_MODE, getAccessToken, triggerRelogin } from "@/auth/authStore"

/**
 * API-Client für Dashboard und Verwaltung. Im Dev-Modus wird der X-Dev-User-Header
 * gesetzt (Backend AUTH_MODE=dev), sonst das Authentik-Access-Token als Bearer.
 * BASE_URL endet mit "/" — Pfad-Betrieb: "/betriebstagebuch/api/v1".
 *
 * Das Terminal nutzt einen eigenen Client (src/lib/terminalApi.ts) mit Chip-Sitzung.
 */
export const api = axios.create({ baseURL: `${import.meta.env.BASE_URL}api/v1` })

if (AUTH_MODE === "dev") {
  api.defaults.headers.common["X-Dev-User"] = JSON.stringify({
    sub: "dev-admin",
    name: "Dev Admin",
    roles: ["admin"],
  })
} else {
  api.interceptors.request.use(async (config) => {
    const token = await getAccessToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  })
  api.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error?.response?.status === 401) triggerRelogin()
      return Promise.reject(error)
    },
  )
}

/** Deutsche Fehlermeldung aus einer API-Antwort ({"detail": "…"}). */
export function fehlertext(error: unknown, ersatz = "Das hat nicht geklappt."): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail
  return typeof detail === "string" ? detail : ersatz
}
